import { Box } from '@hopskipdrive/react-components';

import { CardContainer, CardHeader } from './Card.styles';

const Card = ({ children }) => {
  return <CardContainer>{children}</CardContainer>;
};

const CardBody = ({ children }) => {
  return (
    <Box display="flex" gap="12px" sx={{ width: '100%' }} flexDirection={'column'}>
      {children}
    </Box>
  );
};

Card.Header = CardHeader;
Card.Body = CardBody;

export { Card };
